module.exports = __webpack_public_path__ + "media/application/images/icons/lock_circle-808ef211a3ddfbee7505b6ebfc8d78d5.svg";